import React from 'react';
import Template from './temlate';
import { txtTypeEnum } from '../constants';
import PropTypes from 'prop-types';
import TempleteFooter from "../TempleteFooter";
import styles from "./index.css"
//TODO : 修改参数
const Main = ({dataInfo,additionalUserInfo,useInfo,commentInfo,likeInfo,duration=0}) => {
    // if (dataInfo?.txtType === txtTypeEnum.FORWARD) {
    //     return <ForwardTemplate {...props} dataInfo={dataInfo} />;
    // }
    // let changeTab = (dataInfo) => {
    //     window.open(`http://172.30.21.26:3002/mobile/news/circles/contentDetail?id=${dataInfo.id}&orgId=${dataInfo.orgId}&refreshId=circle_owner_list${dataInfo.orgId}&isCircle=true&isFull=0&immersion=true&ifengsp=1`, "_blank")
    // }
    let isPC= ()=> { //是否为PC端
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone",
            "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }
    return <div style={isPC()?{borderBottom: "1px solid #e7e7e7"}:{}} className={isPC()?styles.containerWhite:""}>
        <Template  footerChildren={
            <TempleteFooter dataInfo={dataInfo} commentInfo={commentInfo} likeInfo={likeInfo}/>
        } additionalUserInfo={additionalUserInfo} useInfo={useInfo} dataInfo={dataInfo} duration={duration} />
    </div>

};

Main.propTypes = {
    /**
     * 帖子详情信息
     */
    dataInfo: PropTypes.object.isRequired,
};

export default Main;
